import React, { useEffect, useRef, useState } from 'react';
// import moment from 'moment';
import '../../assets/css/StudentShortDetails.css';
import studentShortpic from '../../assets/Images/stushortpic.png';
import std from '../../assets/Images/unnaemmeduser.png'
import nexticon from '../../assets/icons/icon.svg';
import { formatDateDDMMYYYY } from '../../Utils/data&dateTime';
import exporticon from '../../assets/icons/export-data.svg';
import addFingerprint from '../../assets/icons/FingerPrint.svg';
import Notifier from '../../Utils/notify'
import { ExceptionalApprovalModal } from '../../Component/Modals/ExceptionalFeeDueApprovalsForActivity';
import { getData, Postdata } from '../../API/GlobalApi';
import { WaitExceptionalApprovalModal } from '../../Component/Modals/WaitFoeExceptionalApprovals';
import { useHasPermission } from '../../Utils/checkPermissions';
import ConfirmationModal from '../../Component/Modals/ConfirmationModal'
import { clearOtpState, getOtpState, saveOtpState } from '../../Utils/storeOtpStates';
import { copyToClipboard } from '../../Utils/copyToClipboard';

export default function SingleLibraryDueDetails({ selectedDetails, activityId, getActivityDatas, currentPage, setselectedStudent, activity, studentInfo, isSearchMode, filterQueryString, searchValue, sortField, sortOrder, setIsSearchMode, setfilterStudent, modalOpenQueryRef, setRefreshKey }) {

    const hasPermission = useHasPermission();

    // console.log("selectedDetails", selectedDetails)
    const [fingerprints, setFingerprints] = useState([null, null, null]);
    const [showFingerprints, setShowFingerprints] = useState(false);
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const otpInputs = useRef([]);
    const [showExceptionalModal, setShowExceptionalModal] = useState(false);
    const [showWaitModal, setShowWaitModal] = useState(false);

    const [otpSent, setOtpSent] = useState(false);
    const [enteredOTP, setEnteredOTP] = useState("");





    const handleOtpChange = (e, index) => {
        const value = e.target.value;

        if (!/^[0-9]?$/.test(value)) return; // allow only digits

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next
        if (value && index < 5) {
            otpInputs.current[index + 1].focus();
        }

        // Backspace → go back
        if (!value && index > 0) {
            otpInputs.current[index - 1].focus();
        }
    };


    const [verifying, setVerifying] = useState(false);

    // const verifyOTP = async () => {

    //     if (verifying) return; // 🔥 prevents double call
    //     const finalOTP = otp.join("");

    //     if (finalOTP.length !== 6) {
    //         Notifier.error("Please enter a valid 6-digit OTP");
    //         return;
    //     }

    //     try {
    //         setVerifying(true);

    //         const payload = {
    //             noc_id: selectedDetails.id,
    //             student_id: selectedDetails.student_id,
    //             otp: finalOTP,
    //         };

    //         const res = await Postdata("academics/activities/verify-library-noc-otp/", payload);

    //         if (res?.message?.toLowerCase().includes("verified")) {
    //             Notifier.success(res?.message);
    //             clearOtpState(selectedDetails.student_id);
    //             // setShowConfirmModal(true);
    //             setOtpSent(false);
    //             setOtp(Array(6).fill(""));
    //             setRefreshKey(prev => prev + 1)
    //             // ----------------------------
    //             // Prepare query correctly
    //             // ----------------------------
    //             const rawQuery =
    //                 modalOpenQueryRef.current?.query ||
    //                 searchValue?.trim() ||
    //                 "";

    //             const formattedQuery = rawQuery
    //                 ? `search=${encodeURIComponent(rawQuery)}`
    //                 : "";

    //             // Fetch latest list
    //             // const resData = await getActivityDatas(
    //             //     currentPage,
    //             //     sortField,
    //             //     sortOrder,
    //             //     formattedQuery,
    //             //     true,
    //             //     true
    //             // );

    //             // Update selected student
    //             // if (resData) {
    //             //     const updatedList = resData.students?.results || [];
    //             //     const updatedStudent = updatedList.find(
    //             //         (s) => s.student_id === selectedDetails?.student_id
    //             //     );
    //             //     if (updatedStudent) setselectedStudent(updatedStudent);
    //             // }
    //             return; // 🔥 VERY IMPORTANT

    //         }
    //         Notifier.error(res?.error || "OTP verification failed");

    //     } catch (error) {
    //         Notifier.error("OTP verification failed");
    //     } finally {
    //         setVerifying(false); // ✅ ONLY state cleanup

    //     }
    // };

    const verifyOTP = async () => {
        if (verifying) return;

        const finalOTP = otp.join("");
        if (finalOTP.length !== 6) {
            Notifier.error("Please enter a valid 6-digit OTP");
            return;
        }

        let verifiedSuccessfully = false;

        try {
            setVerifying(true);

            const res = await Postdata(
                "academics/activities/verify-library-noc-otp/",
                {
                    noc_id: selectedDetails.id,
                    student_id: selectedDetails.student_id,
                    otp: finalOTP,
                }
            );

            if (res?.message?.toLowerCase().includes("verified")) {
                verifiedSuccessfully = true;

                Notifier.success(res.message);

                // 🔥 UI updates AFTER success
                clearOtpState?.(selectedDetails.student_id);
                setOtpSent(false);
                setOtp(Array(6).fill(""));
                setRefreshKey(prev => prev + 1);

                return;
            }

            Notifier.error(res?.error || "OTP verification failed");

        } catch (error) {
            if (!verifiedSuccessfully) {
                Notifier.error("OTP verification failed");
            }
        } finally {
            setVerifying(false);
        }
    };

    const [biometricVerified, setBiometricVerified] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);



    const [loading, setLoading] = useState(false);

    const sendOTP = async () => {
        try {


            setLoading(true);

            const payload = {
                noc_id: selectedDetails?.id,
                student_id: selectedDetails.student_id,
            };

            const res = await Postdata('academics/activities/send-library-noc-otp/', payload);
            console.log("response in otp", res);

            // Backend might return errors as object
            if (res?.mobile) {
                Notifier.info(`OTP sent to ${res.mobile}`);
                setOtpSent(true);
                saveOtpState(selectedDetails.student_id, res.mobile);

                // If resending OTP
                if (otpSent) {
                    setOtp(['', '', '', '', '', '']);
                }
            } else if (res?.error) {
                // API validation errors
                Notifier.error(res?.error);
            } else {
                // Generic fallback
                Notifier.error("Failed to send OTP.");
            }

            setTimeout(() => {
                otpInputs.current[0]?.focus();
            }, 50);
        } catch (error) {
            console.error(error);
            Notifier.error("Failed to send OTP due to network or server error.");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (!selectedDetails) return;

        // Reset OTP fields first
        setOtp(["", "", "", "", "", ""]);
        setEnteredOTP("");
        setFingerprints([null, null, null]);
        setShowFingerprints(false);
        setOtpSent(false);

        // Show OTP only if studentId + mobile match studentInfo
        const isValid =
            selectedDetails.student_id === studentInfo?.userId &&
            selectedDetails.mobile === studentInfo?.mobile;

        if (!isValid) return;

        // Restore previous OTP session if exists
        const session = getOtpState(selectedDetails.student_id, selectedDetails.mobile);
        if (session) {
            setOtpSent(true);
            setTimeout(() => otpInputs.current[0]?.focus(), 100);
        }
    }, [selectedDetails, studentInfo]);



    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);








    if (!selectedDetails) return null;


    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <p style={{ background: '#F9F9F9', padding: '16px', borderRadius: '8px', textAlign: 'left', fontWeight: 500, color: "#222F3E", display: 'flex', justifyContent: 'space-between' }}>Library's NOC SHORT DETAILS:
                    </p>
                </div>
            </div>
            <div className="col-md-12 p-3 stu-pro">
                <div className='row'>
                    <div className='col-md-6'>
                        <p className="stu-title" title='Name & ID'>
                            {selectedDetails.student_name}
                        </p>
                        <p className="sd-p"
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                            onClick={() => copyToClipboard(selectedDetails.registration_number, "Reg No copied")}>{selectedDetails.registration_number}</p>
                    </div>
                    <div className='col-md-6'>
                        {/* <p
                            style={{
                                fontSize: "11px",
                                padding: "8px 15px",
                                borderRadius: "999px",
                                background: "#dcfce7",
                                border: "1px solid #bbf7d0",
                                color: "#166534",
                                display: "inline-block",
                                fontWeight: 600,
                                width: "fit-content",
                                // cursor: "pointer"
                            }}
                        >
                            Ready to issue
                        </p> */}

                    </div>
                </div>


                {/* ---------------- A. PRE-CHECKS SECTION ---------------- */}





                {/* ---------------- B. AUTHENTICATION SECTION ---------------- */}
                <p className="stu-title mt-4">Authentication</p>


                <div
                    className="row mt-2"
                    style={{
                        borderRadius: "8px",
                        border: "1px dashed #7F56DA",
                        padding: "12px 10px",
                        marginBottom: "8px",
                        background: "#f9fafb",
                    }}
                >
                    {(() => {
                        const auth = selectedDetails?.authentication_type;         // OTP / Biometric
                        const isCompleted = selectedDetails?.noc_status === "COMPLETED";
                        const isDisabled = false; // 🔥 No fee due logic in new API

                        const handleAction = () => {
                            if (isCompleted || isDisabled) return;

                            if (auth === "OTP") sendOTP();

                        };

                        return (
                            <>
                                <div className="col-md-6">
                                    <p className="sd-p">{auth}</p>

                                    {auth === "OTP" && selectedDetails?.mobile && (
                                        <p className="sd-p">
                                            <strong>Contact :</strong>{" "}
                                            {studentInfo?.mobile || selectedDetails?.mobile}
                                        </p>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    {auth === "OTP" && otpSent ? (
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "10px",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            {loading ? (
                                                <p>Sending OTP...</p>
                                            ) : (
                                                <>
                                                    {/* OTP Inputs */}
                                                    <div style={{ display: "flex", gap: "4px" }}>
                                                        {otp.map((digit, index) => (
                                                            <input
                                                                key={index}
                                                                type="text"
                                                                value={digit}
                                                                maxLength={1}
                                                                ref={(el) => (otpInputs.current[index] = el)}
                                                                onChange={(e) => handleOtpChange(e, index)}
                                                                // onKeyDown={(e) => {
                                                                //     if (e.key === "Enter") {
                                                                //         const finalOTP = otp.join("");
                                                                //         if (finalOTP.length === 6) verifyOTP();
                                                                //     }
                                                                // }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "Enter") {
                                                                        e.preventDefault();     // ✅ stops default submit
                                                                        e.stopPropagation();    // ✅ stops bubbling

                                                                        const finalOTP = otp.join("");
                                                                        if (finalOTP.length === 6 && !verifying) {
                                                                            verifyOTP();
                                                                        }
                                                                    }
                                                                }}


                                                                // onKeyDown={(e) => {
                                                                //     if (e.key === "Enter" && mobileValue.length === 10) {
                                                                //         e.preventDefault();
                                                                //         handleSaveMobile();
                                                                //     }
                                                                // }}
                                                                style={{
                                                                    width: "32px",
                                                                    height: "32px",
                                                                    textAlign: "center",
                                                                    fontSize: "12px",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #ccc",
                                                                }}
                                                            />
                                                        ))}
                                                    </div>

                                                    {/* Resend + Verify */}
                                                    <div style={{ display: "flex", gap: "8px" }}>
                                                        <button
                                                            style={{
                                                                padding: "6px 14px",
                                                                fontSize: "12px",
                                                                backgroundColor: "#f39c12",
                                                                color: "#fff",
                                                            }}
                                                            onClick={sendOTP}
                                                        >
                                                            Resend OTP
                                                        </button>

                                                        <button
                                                            className="add-btn"
                                                            style={{ padding: "6px 14px", fontSize: "12px" }}
                                                            onClick={verifyOTP}
                                                            disabled={verifying}
                                                        >
                                                            {verifying ? (
                                                                <span
                                                                    className="spinner-border spinner-border-sm"
                                                                    role="status"
                                                                />
                                                            ) : (
                                                                "Verify"
                                                            )}
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ) : (
                                        // Default Badge
                                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <p
                                                className="sd-p"
                                                onClick={handleAction}
                                                style={{
                                                    fontSize: "11px",
                                                    padding: "3px 7px",
                                                    borderRadius: "999px",
                                                    border: isCompleted
                                                        ? "1px solid #bbf7d0"
                                                        : "1px solid #fecaca",
                                                    background: isCompleted ? "#dcfce7" : "#fee2e2",
                                                    color: isCompleted ? "#166534" : "#991b1b",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    whiteSpace: "nowrap",
                                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                                }}
                                                title={
                                                    isCompleted
                                                        ? `${auth} is already completed`
                                                        : `Click to complete ${auth}`
                                                }
                                            >
                                                {isCompleted ? "Completed" : "Pending"}
                                            </p>

                                            {!isCompleted && (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 512 512"
                                                    width="30"
                                                    height="30"
                                                    fill="#7F56DA"
                                                    style={{
                                                        cursor: isDisabled ? 'default' : 'pointer'
                                                    }}

                                                    // onClick={() => handelSendOtp(row)}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAction(); // optional or open OTP
                                                    }}

                                                ><title>{
                                                    isDisabled
                                                        ? "Fee Due Clearance must be completed before this step"
                                                        : isCompleted
                                                            ? `${auth} is already completed`
                                                            : `Click to complete ${auth}`
                                                }</title>
                                                    <path d="M458.5 112H265V62.4A31.4 31.4 0 0 0 233.6 31H62.4A31.4 31.4 0 0 0 31 62.4v387.2A31.4 31.4 0 0 0 62.4 481h171.2A31.4 31.4 0 0 0 265 449.6V292h193.5A22.5 22.5 0 0 0 481 269.5V134.5A22.5 22.5 0 0 0 458.5 112ZM125.5 50.1h45a11.3 11.3 0 0 1 0 22.5h-45a11.3 11.3 0 0 1 0-22.5Zm45 411.8h-45a11.3 11.3 0 1 1 0-22.5h45a11.3 11.3 0 0 1 0 22.5Zm74.7-41.6H50.8V91.8h194.4V112H125.3a22.3 22.3 0 0 0-22.3 22.3V269.7a22.3 22.3 0 0 0 22.3 22.3H166v36.1a11.1 11.1 0 0 0 19 7.9L229 292h16.2ZM220.8 210.2a11.3 11.3 0 0 1-11.3 19.5L195.3 221.4V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4L161.5 202l-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM328.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM436.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3Z" />
                                                </svg>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </>
                        );
                    })()}

                    <p className="sd-p mt-2">Authentication must be completed.</p>
                </div>

                <p className="sd-p mt-2">All authentication steps must be completed.</p>
            </div>

            {/* <ConfirmationModal
                isOpen={showConfirmModal}
                title={`Confirm ${activity?.activity_name} Issue`}
                message={
                    <span>
                        Are you sure you want to issue the{" "}
                        <strong style={{ color: "#7f56da" }}>
                            {activity?.activity_name}
                        </strong>{" "}
                        to{" "}
                        <strong style={{ color: "#7f56da" }}>
                            {selectedDetails?.full_name}
                        </strong>
                        ?
                    </span>
                }
                onConfirm={() => handleIssueAdmitCard()}
                onCancel={() => setShowConfirmModal(false)}
                isSubmitting={isSubmitting}
                triggerOnEnter={true}   // ⭐ ONLY HERE
            /> */}

        </>
    );
}
